import PopupInformation from "shared/components/popups/PopupInformation.js";

const PopupPremiumInfo = ({ trigger }) => {
  return (
    <PopupInformation
      trigger={trigger}
      title={
        <>
          <i className="bi bi-stars me-1"></i>Go Premium!
        </>
      }
      className="popup-lg"
      content={
        <div className="text-white">
          <h4>How to get Premium?</h4>

          <p className="text-white text-lg">
            Choose the subscription plan that best fits your needs using the secure Stripe checkout below. Your Premium
            access will be activated automatically as soon as your subscription is confirmed.
          </p>

          <div className="text-center mb-4">
            <stripe-pricing-table
              pricing-table-id="prctbl_1Tv08ULmTDYuvMT7e6BQoJku"
              publishable-key="pk_live_51Qwm4hLmTDYuvMT7G8j1Xk7pCzA8fS1QvGEPRwxAihZJtyybG4HkH2rqcDRjHuxy15cWFHOrykik99FaHiLKuCSk00OMGcWype"
            ></stripe-pricing-table>
          </div>

          <h4>What's included with Premium?</h4>

          <p className="text-white text-lg">
            Premium unlocks advanced features and removes the limitations of the free plan, giving you the full
            Assistant & Coach experience.
          </p>

          <table className="table table-striped table-hover w-100 bg-black">
            <thead>
              <tr>
                <th>Feature</th>
                <th>Premium</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Data Export</td>
                <td>Export complete datasets with full historical data.</td>
              </tr>
              <tr>
                <td>Formation Meta</td>
                <td>Choose an OVR difference of 11, 22, or 33. Non-premium users are limited to 22.</td>
              </tr>
              <tr>
                <td>Match Planner</td>
                <td>Analyze all planned matches instead of only those taking place within the next 12 hours.</td>
              </tr>
              <tr>
                <td>Squad Builder</td>
                <td>Create unlimited squads.</td>
              </tr>
              <tr>
                <td>Tactic Analysis</td>
                <td>Create unlimited tactic dossiers.</td>
              </tr>
              <tr>
                <td>Player Notification</td>
                <td>
                  • Unlimited player scopes.
                  <br />• Additional filters based on estimated player price.
                </td>
              </tr>
            </tbody>
          </table>

          <p className="mt-3 text-white">
            <strong>Note:</strong> New Premium features are added regularly and are included with every active
            subscription.
          </p>
        </div>
      }
    />
  );
};

export default PopupPremiumInfo;
